<!-- 主页面 -->
<template>
  <div>
    <iframe src="../../static/cityBrain.html" scrolling="no" style="width: 100%;height:100vh;" frameborder="0"></iframe>
  </div>
</template>

<script>

export default {
  data() {
    return {
      
    };
  },
  mounted() {
  
  },

  methods: {
    // 跳转到指挥调度页面函数
    linkLiveVideo() {
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style scoped>
/* 背景图片 */
.main-bgimg {
  overflow: hidden;
  width: 100%;
  height: 100%;
  /* background-color: burlywood; */
  background-image: url(../assets/img/main/main-bg1.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  /* 背景图像固定 */
  background-attachment: fixed;
}

/* 标题栏 */
.main-title {
  width: 100%;
  height: 50px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-title.png);
  background-size: 100% 100%;
}

/* 标题文本 */
.main-title-txt {
  color: #01c5ff;
  font-size: 1.9rem;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
}

/* 中间大盒子 */
.main-box {
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

/* 左侧边框 */
.main-left-box {
  width: 350px;
  height: 98%;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-left-box.png);
  background-size: 100% 100%;
}

/* 中间边框 */
.main-center-box {
  margin-top: -8%;
  width: 900px;
  height: 100px;
  display: flex;
  flex-direction: column;
  /* flex-wrap:wrap; */
  justify-content: center;
  /* align-items:center; */
}

/* 中间上面模块 */
.main-center-top {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
}

/* 中间左上盒子 */
.main-center-leftTop-box {
  width: 240px;
  height: 100px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-center-leftTop-box.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

/* 中间右上盒子 */
.main-center-rightTop-box {
  width: 240px;
  height: 100px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-center-rightTop-box.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

/* 中间左边图标 */
.center-img-left {
  padding-right: 50px;
  width: 40px;
  height: 40px;
}
/* 中间左边文字 */
.center-title-left {
  color: #01c5ff;
  font-size: 1.4rem;
  font-weight: 500;
  text-align: center;
  margin-right: 50px;
  margin-top: 5px;
}

/* 中间右边图标 */
.center-img-right {
  padding-left: 50px;
  width: 40px;
  height: 40px;
}
/* 中间右边文字 */
.center-title-right {
  color: #01c5ff;
  font-size: 1.4rem;
  font-weight: 500;
  text-align: center;
  margin-left: 50px;
  margin-top: 5px;
}

/* 中间下方模块 */
.main-center-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* 中间左下盒子 */
.main-center-leftBottom-box {
  width: 240px;
  height: 100px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-center-leftBottom-box.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

/* 中间右下盒子 */
.main-center-rightBottom-box {
  width: 240px;
  height: 100px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-center-rightBottom-box.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

/* 右侧边框 */
.main-right-box {
  width: 350px;
  height: 98%;
  background-repeat: no-repeat;
  background-image: url(../assets/img/main/main-right-box.png);
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/cityBrain.vue